import React from "react";
import { Edit as EditIcon, Delete as DeleteIcon, PublishedWithChangesRounded, } from "@mui/icons-material"; import { useEffect, useState } from "react";
import axios from "axios";
import { Autocomplete, Box, Button, Card, CardContent, CardHeader, Grid, IconButton, TextField, Tooltip, Typography, } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import { catalogoSave, catalogoDelete, catalogoUpdate } from "../../../services/CatalogoServices";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import MUIXDataGrid from "../../Ayuda/MUIXDataGrid";
import { crudService } from "../../../services/CrudService";

export interface FondosInterface {
  id: string;
  clave: string;
  nombre: string;
  fecha_alta: string;
  creadopor: string;
  modificadopor: string;
  eliminadopor: string;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 5,
  p: 2,
};

export default function Fondos() {
  const TITULO = "Catálogo de Fondos";
  const TITULODETALLE = "Detalle de Fondos";
  const BASEURL = `catalogos/fondos`;
  document.title = TITULO;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [id, setid] = useState("");
  const [nombreManual, setNombreManual] = useState(""); // Estado para el TextField
  const [nombre, setNombre] = useState("");
  const [clave, setClave] = useState("");
  const [orden, setOrden] = useState<number | null>(null);
  const [open, setOpen] = React.useState(false);
  const [cveDist, setCveDist] = useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const esEdicion = id !== "";
  const [catalogoTiposPublicacion, setCatalogoTiposPublicacion] = useState<FondosInterface[]>([]);
  const [tipoPublicacion, setTipoPublicacion] = useState<string | undefined>(undefined);
  const handleSave = async () => {
    try {
      const newPublicacion = { nombre, clave, clave_dist: cveDist, orden, tipo_id: tipoPublicacion }
      await crudService(BASEURL, 'crear', null, newPublicacion).then(
        () => window.location.reload()
      )
    } catch (error) {
      console.error("Error al crear Enlace:", error);
    }
  };

  const handleDelete = async (id: string) => {
    Swal.fire({
      icon: "warning",
      title: "Dar de baja",
      text: "¿Estás seguro de que deseas dar de baja este Fondo?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "baja", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Baja",
              text: "El Fondo ha sido dada de baja.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo dar de baja el Fondo.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo dar de baja el Fondo.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };

  const handleRecover = async (id: string) => {
    Swal.fire({
      icon: "info",
      title: "Recuperar",
      text: "¿Estás seguro de que deseas recuperar este Fondo?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "recupera", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Recuperado",
              text: "El Fondo ha sido recuperada.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo recuperar el Fondo.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo recuperar el Fondo.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };
  const handleUpdate = async () => {
    if (!nombre || !clave || orden === null || !cveDist) {
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        text: "Favor de completar los campos",
        confirmButtonColor: "#15212f",
      });
    } else {
      try {
        const data = { nombre, tipo_id: tipoPublicacion };
        const response = await crudService(BASEURL, "actualizar", id, data);
        if (response.success) {
          Swal.fire({
            icon: "success",
            title: "Recuperado",
            text: "El Fondo ha sido actualizada.",
            confirmButtonColor: "#15212f",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.message || "No se pudo actualizar el Fondo.",
            confirmButtonColor: "#15212f",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar el Fondo.",
          confirmButtonColor: "#15212f",
        });
      }
    }
  };


  const obtenerCatalogo = async (): Promise<void> => {
    setLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_APPLICATION_ENDPOINT}/catalogos/fondos/tipos`; // Corrección en la concatenación de la URL
      const { status, data: result } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem("jwtToken") || "",
          "Content-Type": "application/json",
        },
      });
   

      if (status !== 200) {
        throw new Error(`Error HTTP: ${status}`);
      }

      const data: FondosInterface[] = result.data || []; // Asegura que `data` sea un array
      if (data.length === 0) {
        console.warn('El catálogo está vacío');
      } else {

        setCatalogoTiposPublicacion(data); // Actualiza el estado con los datos
      }

    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Error desconocido";
      console.error("Error al obtener el catálogo:", errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    obtenerCatalogo();
  }, []); // Dependencias vacías aseguran que solo se ejecute al montar

  const columns = [
    {
      field: "acciones",
      headerName: "Acciones",
      width: 150,
      headerAlign: "left",
      hideable: false,
      renderCell: (cellValues: any) => {
        return (
          <Box>
            <Tooltip title={"Editar"}>
              <IconButton color="inherit"
                onClick={() => {
                  setid(cellValues.row.id);
                  setNombre(cellValues.row.nombre);
                  setClave(cellValues.row.clave);
                  setOrden(cellValues.row.orden);
                  setCveDist(cellValues.row.clave_dist);
                  setTipoPublicacion(cellValues.row.tipo_id);
                  handleOpen();
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            {
              cellValues.row.estatus == 'ACTIVO' ?
                <Tooltip title={"Eliminar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleDelete(cellValues.row.id); }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title={"Recuperar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleRecover(cellValues.row.id); }}
                  >
                    <PublishedWithChangesRounded />
                  </IconButton>
                </Tooltip>
            }
          </Box>
        );
      },
    },
    {
      field: "clave",
      headerName: "Clave",
      width: 200,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "clave_dist",
      headerName: "Clave Dist",
      width: 200,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "nombre",
      headerName: "Nombre",
      width: 400,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "tipo_nombre",
      headerName: "Tipo Nombre",
      width: 200,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "orden",
      headerName: "Orden",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
  ];
  const camposCsv = ["Cve", "cveDist", "nombre", "orden", "catalogoTipo", "estatus"];
  const [rows, setRows] = useState([]);
  const getAllFondos = async () => {
    const response = await crudService(BASEURL, 'obtener');
    if (response?.data) {
      setRows(response.data)
    }
  };

  useEffect(() => {
    getAllFondos();
  }, []);


  useEffect(() => {
    // Limpieza de campos al cerrar la modal
    if (!open) {
      setNombre("");
      setClave("");
      setOrden(null);
      setCveDist("");
      setTipoPublicacion(undefined);
    }
  }, [open]);

  return (
    <Grid container sx={{}}>
      <BreadcrumbBar
        links={[
          { texto: 'Inicio', link: '/admin' },
          { texto: 'Catálogos', link: '/admin/catalogos' }
        ]
        }
        Titulo={TITULO}
      />
      <Grid container xs={12} justifyContent={"center"}>
        <Grid item xs={12} md={12} mt={2}>
          <Card sx={{ p: 0, boxShadow: 8 }}>
            <CardHeader sx={{ position: "absolute", fontFamily: "MontserratSemiBold" }} />
            <Typography variant="h5" sx={{ paddingTop: "1%", paddingLeft: "1%" }}>  {TITULO} </Typography>
            <CardContent sx={{ fontFamily: "MontserratBold", bgcolor: "" }}>
              <Box display="flex" justifyContent="flex-end">
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "right",
                    justifyContent: "right",
                    paddingBottom: "2%",
                    paddingRight: "1%",
                  }}
                >
                  <Button
                    onClick={handleOpen}
                    variant="contained"
                    sx={{ margin: "1%", color: "#FFFFFF" }}
                  >
                    <Typography
                      sx={{
                        color: "#FFFFFF", "&:hover": { color: "#15212f" },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}
                    >
                      Agregar
                    </Typography>
                  </Button>
                  <Button
                    onClick={() => navigate(-1)}
                    color="secondary"
                    sx={{ margin: "1%" }}
                    variant="contained">
                    <Typography
                      sx={{
                        color: "#ffffff",
                        "&:hover": {
                          color: "#15212f",
                        },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}>
                      Cancelar
                    </Typography>
                  </Button>
                </Grid>
              </Box>
              <MUIXDataGrid id={Math.random} columns={columns} rows={rows} camposCsv={camposCsv} />
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} display="flow">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="h5" sx={{ padding: "1%" }}>
                          {TITULODETALLE}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label="Clave"
                          size="small"
                          variant="outlined"
                          value={clave}
                          disabled={id !== "" ? true : false}
                          onChange={(v) => { setClave(v.target.value); }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                    <Box
                      component="form"
                      sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                      noValidate
                      autoComplete="off"
                      display="flex"
                    >
                      <TextField
                        inputProps={{ maxLength: 256 }}
                        label="Clave Dist"
                        size="small"
                        variant="outlined"
                        value={cveDist}
                        disabled={id !== "" ? true : false}
                        onChange={(v) => { setCveDist(v.target.value); }}
                      />
                    </Box>
                    </Grid>
                    <Grid item xs={6}>
                    <Box
                      component="form"
                      sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                      noValidate
                      autoComplete="off"
                      display="flex"
                    >
                      <TextField
                        inputProps={{ maxLength: 256 }}
                        label="Nombre"
                        size="small"
                        variant="outlined"
                        value={nombre}
                        onChange={(v) => { setNombre(v.target.value); }}
                      />
                    </Box>
                    </Grid>
                    <Grid item xs={6}>
                    <Box
                      component="form"
                      sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                      noValidate
                      autoComplete="off"
                      display="flex"
                    >
                      <TextField
                        inputProps={{ maxLength: 256 }}
                        label="Orden"
                        size="small"
                        variant="outlined"
                        value={orden ?? ""}
                        disabled={id !== "" ? true : false}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Asegurarse de que el valor sea un número
                          setOrden(value === "" ? null : parseInt(value, 10));  // Si está vacío, se establece como null
                        }}
                      />
                    </Box>
                    </Grid>
                    <Grid item xs={6}>
                    <Box
                      component="form"
                      sx={{ "& > :not(style)": { m: 1.3, width: "100%" } }}
                      noValidate
                      autoComplete="off"
                      display="flex"
                    >
                      <Autocomplete
                        id="tipo-publicacion"
                        options={catalogoTiposPublicacion}
                        getOptionLabel={(option) => option.nombre}
                        value={catalogoTiposPublicacion.find((p) => p.id === tipoPublicacion) || null}
                        onChange={(_, newValue) => setTipoPublicacion(newValue?.id)}
                        renderInput={(params) => (
                          <TextField {...params} label="Selecciona un tipo" placeholder="Selecciona un tipo" />
                        )}
                        disabled={loading}
                      />
                    </Box>
                    </Grid>
                
                    <Grid item xs={12}>
                      <Box
                        maxWidth="100%"
                        paddingTop={2}
                        paddingBottom={2}
                        display="flex"
                        justifyContent="end"
                      >
                        <Button
                          onClick={() => {
                            if (id === "") {
                              handleSave()
                            } else {
                              handleUpdate()
                            }
                          }
                          }
                          variant="contained"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Guardar
                        </Button>
                        <Button
                          onClick={handleClose}
                          variant="contained"
                          color="secondary"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}